<script>
export default {
  name: 'Accordion',
  props: {
    title: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    toggleAccordion() {
      if (!this.disabled) {
        this.active = !this.active;
      }
    }
  },
};
</script>

<template>
  <div class="sf-accordion">
      <div class="header" :class="{disabled: disabled}" @click.prevent="toggleAccordion()">
        <a href="#" class="accordion-link" >
          <strong>{{ title }}</strong>
          <img :class="{rotate:active}" src="@/assets/starface_icons_png/24/dark_gray/arrow_down_short.png" alt="Arrow icon" />
        </a>
      </div>
      <div v-if="!disabled" class="accordion-content" v-show="active"><slot /></div>
    </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.sf-accordion {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 40px;
  .header {
    display: block;
    .accordion-link {
      color: $grey-dark;
      display: flex;
      border-width: 0;
      border-style: solid;
      border-color: $grey-brighter;
      background: $grey-brighter;
      justify-content: space-between;
      padding: 8px 24px;
      img {
        &.rotate{
          transform: rotate(180deg);
        }
      }
    }
    &.disabled {
      opacity: 0.4;
      .accordion-link {
        cursor: not-allowed;
      }
    }
  }
  .accordion-content {
    padding: 0px 20px;
  }
}
</style>
